import { BaseError } from './BaseError';

export enum NotificationPermissionErrorReason {
    Denied = 'Denied',
    Dismissed = 'Dismissed',
    Unknown = 'Unknown',
}

export class NotificationPermissionError extends BaseError {
    reason: NotificationPermissionErrorReason;

    constructor(reason: keyof typeof NotificationPermissionErrorReason) {
        let errorMsg: string = '';

        switch (reason) {
            case NotificationPermissionErrorReason.Denied:
                errorMsg = `The browser notifications permission is denied.`;
                break;
            case NotificationPermissionErrorReason.Dismissed:
                errorMsg = `The browser permission interstitial was dismissed.`;
                break;
            case NotificationPermissionErrorReason.Unknown:
                errorMsg = `Unknown error when getting native browser permission.`;
                break;
            default:
                break;
        }

        super(errorMsg);

        this.reason = NotificationPermissionErrorReason[reason];

        Object.setPrototypeOf(this, NotificationPermissionError.prototype);
    }
}
